import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { EmojiClickData } from "emoji-picker-react";
import { PostFormObject } from "utils/types/generalTypes";

export type PostFormState = {
    postGroup: PostFormObject[];
    emojiPostId: number;
    gifPostId: number;
    emojiModalPosition: { left: number; top: number };
};

export type AddEmojiActionObject = {
    emoji: EmojiClickData;
    id: number;
};

const initialState: PostFormState = {
    postGroup: [
        {
            id: 1,
            type: "post",
            text: "",
            mediaType: null,
            isValid: false
        }
    ],
    emojiPostId: 0,
    gifPostId: 0,
    emojiModalPosition: { left: 0, top: 0 }
};

export const postFormSlice = createSlice({
    name: "postFrom",
    initialState,
    reducers: {
        rUpdatePost: (state, action: PayloadAction<PostFormObject>) => {
            const tempGroup = state.postGroup.map((p) => {
                if (p.id == action.payload.id) {
                    return action.payload;
                } else {
                    return p;
                }
            });
            state.postGroup = tempGroup;
        },
        addEmoji: (state, action: PayloadAction<EmojiClickData>) => {
            const tempGroup = state.postGroup.map((p) => {
                if (p.id == state.emojiPostId) {
                    return {
                        ...p,
                        text: `${p.text} ${action.payload.emoji}`
                    };
                } else {
                    return p;
                }
            });
            state.postGroup = tempGroup;
        },
        setEmojiPostId: (state, action: PayloadAction<number>) => {
            state.emojiPostId = action.payload;
        },
        setGifPostId: (state, action: PayloadAction<number>) => {
            state.gifPostId = action.payload;
        },
        addGif: (state, action: PayloadAction<string>) => {
            const tempGroup = state.postGroup.map((p) => {
                if (p.id == state.gifPostId) {
                    const tempP: PostFormObject = {
                        ...p,
                        gif: action.payload,
                        mediaType: "gif",
                        images: undefined,
                        video: undefined,
                        poll: undefined
                    };
                    return tempP;
                } else {
                    return p;
                }
            });
            state.postGroup = tempGroup;
        },
        rRemovePost: (state, action: PayloadAction<number>) => {
            state.postGroup = state.postGroup.filter(
                (p) => p.id != action.payload
            );
        },
        setEmojiModalPostion: (
            state,
            action: PayloadAction<{ left: number; top: number }>
        ) => {
            state.emojiModalPosition = action.payload;
        },
        addPost: (state) => {
            const postId = state.postGroup[state.postGroup.length - 1].id + 1;
            const newPost: PostFormObject = {
                id: postId,
                type: "post",
                text: "",
                mediaType: null,
                isValid: false
            };
            state.postGroup = [...state.postGroup, newPost];
        }
    }
});

export const {
    rUpdatePost,
    addEmoji,
    setEmojiPostId,
    setGifPostId,
    addGif,
    rRemovePost,
    setEmojiModalPostion,
    addPost
} = postFormSlice.actions;

export default postFormSlice.reducer;
